export const default_api = window.location.href.includes('dev') || window.location.href.includes('localhost') ? "http://45.32.112.59:3301/v1" : "https://api.paboi.bigio.id/v1";
